export default __webpack_public_path__ + "static/media/logo.1530b7d3.svg";